export const ANALYTICS_SEGMENT_ENABLED = 'analytics_segment_web';
export const ANALYTICS_GA_ENABLED = 'analytics_ga_web';
export const ANALYTICS_GTM_ENABLED = 'analytics_gtm_web';
export const ANALYTICS_EC_ENABLED = 'analytics_ec_web';
